module.exports = __webpack_public_path__ + "img/daglibrugsen.dab6621e.png";